import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../services/api';

export const addStudentToClass = createAsyncThunk(
  'students/addStudentToClass',
  async ({ classId, studentData }) => {
    const response = await api.addStudentToClass(classId, studentData);
    return response.data;
  }
);

export const updateStudent = createAsyncThunk(
  'students/updateStudent',
  async ({ id, data }) => {
    const response = await api.updateStudent(id, data);
    return response.data;
  }
);

export const removeStudent = createAsyncThunk('students/removeStudent', async (id) => {
  await api.removeStudent(id);
  return id;
});

export const moveStudent = createAsyncThunk(
  'students/moveStudent',
  async ({ studentId, targetClassId }) => {
    const response = await api.moveStudent(studentId, targetClassId);
    return response.data;
  }
);

const studentsSlice = createSlice({
  name: 'students',
  initialState: {
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addStudentToClass.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStudentToClass.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addStudentToClass.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default studentsSlice.reducer;

